module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dYfu13/images/9780316216678.jpg?1733067555069",
      "alt": "This image is the cover for the book Ordeal of Gilbert Pinfold"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ordeal of Gilbert Pinfold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("\"The very model of the modern paranoid novel\" ("), _c('i', [_vm._v("New York Times")]), _vm._v(") and an ambitious work of semi-autobiographical fiction from one of England's greatest novelists. ")]), _c('br'), _c('br'), _vm._v("Gilbert Pinfold is a reclusive Catholic novelist suffering from acute inertia. In an attempt to defeat insomnia he has been imbibing an unappetizing cocktail of bromide, chloral, and creme de menthe. He books a passage on the SS "), _c('i', [_vm._v("Caliban ")]), _vm._v("and, as it cruises towards Ceylon, rapidly slips into madness."), _c('br'), _c('br'), _vm._v("Almost as soon as the gangplank lifts, Pinfold hears sounds coming out of the ceiling of his cabin: wild jazz bands, barking dogs, and loud revival meetings. He is convinced that an erratic public-address system is letting him hear everything that goes on aboard ship . . . until instead of just sounds he hears voices. And not just any voices. These voices are talking, in the most frighteningly intimate way, about him!"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Evelyn Waugh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("&lt;DIV&gt;Evelyn Waugh (1903-1966), whom &lt;I&gt;Time&lt;/I&gt; called \"one of the century's great masters of English prose,\" wrote several widely acclaimed novels as well as volumes of biography, memoir, travel writing, and journalism. Three of his novels, &lt;I&gt;A Handful of Dust, Scoop, &lt;/I&gt;and&lt;I&gt; Brideshead Revisited,&lt;/I&gt; were selected by the Modern Library as among the 100 best novels of the twentieth century.&lt;/DIV&gt;")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0